var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-select',_vm._g(_vm._b({attrs:{"items":_vm.items,"placeholder":_vm.$l.t('app.select-service-type', 'Select your service type')},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'w-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }